import { FromSchema } from '@40seas/entities/common';
import { z } from 'zod';

export const FinancialConnectionProviderFieldsPersonalGuaranteeSchema = z
    .object({
        email: z.string(),
    })
    .strict();

export class FinancialConnectionProviderFieldsPersonalGuarantee extends FromSchema(
    FinancialConnectionProviderFieldsPersonalGuaranteeSchema,
) {
    email: string;
}
